module.exports = __webpack_public_path__ + "img/contact.b8451cef.svg";